import React from 'react';

interface RightArrowIconProps {
  className?: string;
  color?: string;
  size?: number;
}

export const RightArrowIcon: React.FC<RightArrowIconProps> = ({
  className = '',
  color = 'currentColor',
  size = 11,
}) => {
  return (
    <svg
      width={size}
      height={size * 1.545}
      viewBox="0 0 11 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.5 1L9 8.5L0.5 16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};